import { InvalidUpdateHandlerError } from "./InvalidUpdateHandlerError";
import axios from "axios";
import { QueueNumberCodec, QueueNumber } from "@dqm/queue-number";
import { InvalidResponseError } from "@dqm/core-types";
export class EnqueueService {
  currentNumber: QueueNumber | null = null;
  updateHandlers: Array<Function> = [];

  async start(): Promise<void> {
    this.currentNumber = null;
  }

  async enqueue(payload: {} | undefined = undefined): Promise<QueueNumber> {
    if (payload !== undefined) {
      this.currentNumber = await this.fetchWithPayload(payload);
    } else {
      this.currentNumber = await this.fetch();
    }
    this.updateHandlers.map((fn) => fn(this.currentNumber));

    return this.currentNumber;
  }

  protected async fetch(): Promise<QueueNumber> {
    const { data, status } = await axios.get(
      process.env.REACT_APP_HOST + "/enqueue/next"
    );

    if (status === 204) throw new InvalidResponseError();

    return this.formatResponse(data);
  }

  protected async fetchWithPayload(payload: {}): Promise<QueueNumber> {
    const { data, status } = await axios.post(
      process.env.REACT_APP_HOST + "/enqueue/next",
      payload
    );

    if (status === 204) throw new InvalidResponseError();

    return this.formatResponse(data);
  }

  protected async formatResponse(data: any): Promise<QueueNumber> {
    const codec = new QueueNumberCodec();
    return codec.fromJson(data);
  }

  current(): QueueNumber | null {
    return this.currentNumber;
  }

  registerUpdateHandler(fn: (number: QueueNumber) => void) {
    this.updateHandlers.push(fn);
  }

  unregisterUpdateHandler(fn: (number: QueueNumber) => void) {
    const index = this.updateHandlers.indexOf(fn);
    if (index < 0)
      throw new InvalidUpdateHandlerError("Function is not registered.");

    this.updateHandlers.splice(index, 1);
  }
}
